<script setup>
// التحديث الصامت — الـ SW الجديد ينتظر ويُطبّق عند إعادة فتح التطبيق
</script>

<template><span /></template>
